// Only passive formats may be served inline. Never infer this from a filename.
export const imagePreviewTypes = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
];
export const videoPreviewTypes = ["video/mp4", "video/webm", "video/ogg"];
export const audioPreviewTypes = [
  "audio/mpeg",
  "audio/mp4",
  "audio/webm",
  "audio/ogg",
  "audio/wav",
  "audio/x-wav",
  "audio/flac",
];
export function attachmentPreviewKind(mime: string) {
  const type = mime.split(";", 1)[0].trim().toLowerCase();
  if (imagePreviewTypes.includes(type)) return "image";
  if (videoPreviewTypes.includes(type)) return "video";
  if (audioPreviewTypes.includes(type)) return "audio";
  if (type === "application/pdf") return "pdf";
  return "text";
}
